import React, {ComponentType} from "react";
import BookingOverview from "./index";
import {IProps, IContainerProps, IServices, classPrefix, IHandlers} from './types';

/**
* Gets the interface types as array of strings so we don't need hand code them each time (and reduces chance for mistakes).
*/
import {hot} from "react-hot-loader";
import {keys} from 'ts-transformer-keys';
import ReactUtilsService from "app/services/reactUtils.service";
import { MakeBookingNotes, GetPaymentDetails, GetPaymentSummary, ComputeLinesOccupiedByBookingOptions } from "./helper";
import AdminService from "external-services/diary-admin-service/admin.service";
import { BookingType } from "shared-types/index";
import ManagerService from "external-services/manager-service/manager.service";
import StatusConfigService from 'external-services/status-config-service';
import store from "appRoot/Store";
import {useSelector} from "react-redux";
import {DiaryRootState} from "appRoot/rootReducer";
import {Provider} from "react-redux";

const NS = 'BookingOverviewContainer';


const propsKeys: string[] = keys<IProps>();
const servicesKeys: string[] = keys<IServices>();
const containerPropsKeys: string[] = keys<IContainerProps>();

const ThemeWrap = function(all: IProps & IContainerProps) {

  const fullStatusOptions = useSelector(
    (state: DiaryRootState) => state.statusReducer.fullStatusOptions
  );

  /**
    * Sorts 'all' into IProps and IContainerProps
    */
  const props: IProps = ReactUtilsService.getObjectByKeys(all, propsKeys) as IProps;
  const {bookingInfo, customerInfo, bookingLinks, venueId, handleEmailSmsNotification}: IContainerProps = ReactUtilsService.getObjectByKeys(all, containerPropsKeys) as IContainerProps;

  props.isManager = ManagerService.isManager;
  props.bookingInfo = bookingInfo;
  props.bookingLinks = bookingLinks;
  props.bookingNotesInfo = MakeBookingNotes(bookingInfo.notes, customerInfo);
  props.linesOccupiedByBookingOptions = ComputeLinesOccupiedByBookingOptions(bookingInfo.selectedOptions);
  props.linesOccupiedByUpsellOptions = ComputeLinesOccupiedByBookingOptions(bookingInfo.selectedOptions, true);
  const paymentDetails = GetPaymentDetails(bookingInfo.paymentDetails);

  props.isSmsEnabled = AdminService.getVenue().smsEnabled;
  props.isStandbyOrWaitlist = bookingInfo.bookingType === BookingType.StandbyList || bookingInfo.bookingType === BookingType.WaitList;

  if (bookingInfo.paymentSummary) {
    paymentDetails.price = bookingInfo.paymentSummary.amountDue.toFixed(2).toString();
  }

  props.paymentInfo = !!paymentDetails.paymentType ? paymentDetails : GetPaymentSummary(bookingInfo.paymentSummary, bookingInfo.paymentPending);
  props.customerId = customerInfo._id;
  props.venueId = venueId;

  const handlers: IHandlers = {
    handleEmailSmsNotification: (stopNotification: boolean)=>{
      handleEmailSmsNotification(stopNotification)
    },
    isStatusNameInList: (statusName: string, types: string[]) => {
      return StatusConfigService.checkStatusOptions(statusName, types, fullStatusOptions);
    }
  }

  return ReactUtilsService.containerWrap(
    <BookingOverview {...props} {...handlers} />, classPrefix
  );
}

const StoreWrap = function (props: IProps & IContainerProps) {
  return (
    <Provider store={store}>
      <ThemeWrap {...props} />
    </Provider>
  )
}

/**
 * Returns properties needed for rendering react2angular
 */
export const R2ABookingOverview: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(StoreWrap) as ComponentType<unknown>,
  [...containerPropsKeys] as never[],
  servicesKeys
];
